import React from "react";
import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Resuelve la pantalla inicial según la prioridad:
// 1) Menú Principal configurado y accesible → ese reporte
// 2) Sin configurar → Dashboard (Estructura Organizacional)
// 3) Configurado pero sin acceso → Dashboard (si tiene acceso)
// 4) Sin acceso al Dashboard → primer reporte disponible
export default function Home() {
  const { user, loading } = useAuth();
  const { data: menu, isLoading } = useQuery({
    queryKey: ["menu"],
    queryFn: async () => (await api.get("/menu")).data,
    enabled: !!user,
  });
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (isLoading || !menu) return null;

  const flat = [];
  const walk = (t) => (t || []).forEach((n) => { if (n.route) flat.push(n); walk(n.children); });
  walk(menu);
  const byId = Object.fromEntries(flat.map((n) => [n.id, n]));

  const home = user.home_menu_id ? byId[user.home_menu_id] : null;
  const dash = byId["estructura_organizacional"];
  const target = (home && home.route) || (dash && dash.route) || (flat[0] && flat[0].route) || "/estructura";
  return <Navigate to={target} replace />;
}
